import "./css/output.css";
export default function LabeledValue({
  label,
  value,
  labelAttr,
  className,
  ...props
}) {
  const computedClassName = ["output", "labeled-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <>
          <strong>{label}</strong>&nbsp;
        </>
      )}
      <span>
        {(labelAttr instanceof Function && labelAttr(value)) ||
          value[labelAttr]}
      </span>
    </div>
  );
}

LabeledValue.defaultProps = {
  className: "",
};
